const RejectionReason = {
  SOLD_OUT: 'SOLD_OUT',
  ROOMS_UNAVAILABLE: 'ROOMS_UNAVAILABLE',
  BOOKING_RESTRICTIONS_NOT_MET: 'BOOKING_RESTRICTIONS_NOT_MET',
  BLACKED_OUT: 'BLACKED_OUT',
  OTHER: 'OTHER'
};

export default RejectionReason;
